export default __webpack_public_path__ + "static/media/Digital Keys.97fdfb76.svg";